import React, { useContext } from 'react';
import DeliveryBlock from './DeliveryBlock';
import './style/Favourites.css';
import { FavoriteContext } from './FavoriteContext'; // Импортируем контекст избранного
import CardProduct from './CardProduct'; // Импортируем компонент карточки товара

const Favourites = () => {
  const { favorites } = useContext(FavoriteContext); // Используем контекст избранного

  return (
    <div className="favourites">
      <DeliveryBlock />
      <h2>Избранное</h2>
      <div className="favorites-product-cards">
        {favorites.length === 0 ? (
          <p>Нет избранных товаров</p>
        ) : (
          favorites.map((product) => (
            <CardProduct key={product.id} product={product} />
          ))
        )}
      </div>
    </div>
  );
};

export default Favourites;
